import css from '../nibTable.module.sass';
import Edit from './Edit';
import Remove from './Remove';

const TBody = ({
  customEditIcon,
  getTableBodyProps,
  rowToEdit,
  prepareRow,
  removeRow,
  rows,
  onEditSave,
  editRow,
  readOnly,
}) => {
  return (
    <tbody {...getTableBodyProps()}>
      {rows.map((row, i) => {
        prepareRow(row);
        return (
          <tr {...row.getRowProps()}>
            {!readOnly && (
              <>
                <td className={css.edit}>
                  {row.index === rowToEdit.index && rowToEdit.status ? (
                    <Edit status={true} onClick={() => onEditSave()} />
                  ) : (
                    <Edit status={false} customEditIcon={customEditIcon} onClick={() => editRow(row)} />
                  )}
                </td>
                <td className={css.edit}>
                  <Remove
                    status={row.index === rowToEdit.index && rowToEdit.status ? true : false}
                    onClick={() => removeRow(row)}
                  />
                </td>
              </>
            )}
            {row.cells.map((cell) => {
              return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

export default TBody;
